// @ts-ignore
import * as Types from '@recordset-local/types/graphql/generatedTypes'

// This is the main condition to be fullfiled to consider project as paid on the client.
// Server checks also the "paid" flag of the project which is not exposed to GQL but that's just a helper
// to simplify the MongoDB queries and it also allows us to let users preview the project in the web app
// without caching the project as paid in the mobile app (web app shows all projects with the flag "isPaid")
export const isPaid = (project: Pick<Types.ProjectDetails, 'payment'>) =>
  project.payment !== null && project.payment.confirmedDate !== null
